import React, { useState } from 'react';
import './TalentRequestForm.css';

const TalentRequestForm = () => {
  const [activeSection, setActiveSection] = useState('s-position');
  const [openingsCount, setOpeningsCount] = useState(1);

  const goSec = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActiveSection(id);
  };

  const addOpening = () => {
    setOpeningsCount(prev => prev + 1);
    toast('New opening added');
  };

  const removeOpening = () => {
    if (openingsCount > 1) {
      setOpeningsCount(prev => prev - 1);
    }
  };

  const submitRequest = () => {
    toast('Talent request submitted — HR has been notified');
    setTimeout(() => {
      window.location.href = 'recruitment-talent-requests.html';
    }, 1800);
  };

  const toast = (msg, type = 'success') => {
    const t = document.createElement('div');
    t.className = 'og-toast';
    const color = type === 'error' ? '#f87171' : '#4ade80';
    t.innerHTML = `<i class="fa-solid fa-check-circle" style="color:${color};"></i>${msg}`;
    document.body.appendChild(t);
    setTimeout(() => {
      t.style.opacity = '0';
      setTimeout(() => t.remove(), 300);
    }, 2800);
  };

  return (
    <>
      

      <div className="">
        <div className="topbar">
          <i className="fa-solid fa-clipboard-list" style={{ color: 'var(--primary)' }}></i>
          <div className="breadcrumb" style={{ margin: '0' }}>
            <a href="recruitment-talent-requests.html">Talent Requests</a>
            <i className="fa-solid fa-chevron-right" style={{ fontSize: '.6rem' }}></i>
            <strong style={{ color: 'var(--text)' }}>New Request</strong>
          </div>
          <div className="top-right">
            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
              <div className="top-avatar">AM</div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '.8rem' }}>Arun Mishra</div>
                <div style={{ fontSize: '.68rem', color: 'var(--muted)' }}>HR Admin</div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid position-relation">
          <div className='page-hd'>
              <div className='Page-head'>
            <div className='leftside-head'>
              <h2 >
                <i className="fa-solid fa-clipboard-list"></i>
                Raise Talent Request
              </h2>
              <div className="breadcrumb">Request HR to open a new hiring position</div>
            </div>
            <button className="btn btn-outline btn-sm" onClick={() => window.location.href = 'recruitment-talent-requests.html'}>
              <i className="fa-solid fa-arrow-left"></i> Back
            </button>
            </div>
          </div>

          <div className="form-layout">

  {/* Form Navigation */}
  <div className="form-nav">

    <div
      className="fn-item active"
      onClick={(e) => goSec("s-position", e.currentTarget)}
    >
      <i className="fa-solid fa-briefcase"></i>
      Position
    </div>

    <div
      className="fn-item"
      onClick={(e) => goSec("s-openings", e.currentTarget)}
    >
      <i className="fa-solid fa-users"></i>
      Openings
    </div>

    <div
      className="fn-item"
      onClick={(e) => goSec("s-comp", e.currentTarget)}
    >
      <i className="fa-solid fa-indian-rupee-sign"></i>
      Budget
    </div>

    <div
      className="fn-item"
      onClick={(e) => goSec("s-reason", e.currentTarget)}
    >
      <i className="fa-solid fa-file-lines"></i>
      Justification
    </div>

    <div
      className="fn-item"
      onClick={(e) => goSec("s-priority", e.currentTarget)}
    >
      <i className="fa-solid fa-flag"></i>
      Priority
    </div>

    <div
      className="fn-item"
      onClick={(e) => goSec("s-notes", e.currentTarget)}
    >
      <i className="fa-solid fa-note-sticky"></i>
      Notes for HR
    </div>

  </div>

  <div>

    {/* Position Details */}
    <div className="fs-bx" id="s-position">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-briefcase"></i>
        <h4>Position Details</h4>
      </div>

      <div className="fs-body">

        <div className="form-row form-row-2">

          <div className="fg">
            <label>
              Position / Role Title <span className="req">*</span>
            </label>

            <input
              className="og-input"
              placeholder="e.g. Senior Product Designer"
            />
          </div>

          <div className="fg">
            <label>
              Department <span className="req">*</span>
            </label>

            <select className="og-select">
              <option value="">Select department…</option>
              <option>Engineering</option>
              <option>Product</option>
              <option>Design</option>
              <option>HR</option>
              <option>Analytics</option>
              <option>Marketing</option>
              <option>Finance</option>
              <option>Operations</option>
            </select>
          </div>

        </div>

        <div className="form-row form-row-3">

          <div className="fg">
            <label>
              Employment Type <span className="req">*</span>
            </label>

            <select className="og-select">
              <option>Full-time</option>
              <option>Part-time</option>
              <option>Contract</option>
              <option>Internship</option>
            </select>
          </div>

          <div className="fg">
            <label>Work Mode</label>

            <select className="og-select">
              <option>On-site</option>
              <option>Remote</option>
              <option>Hybrid</option>
            </select>
          </div>

          <div className="fg">
            <label>Experience Required</label>

            <select className="og-select">
              <option>0–2 years</option>
              <option>2–4 years</option>
              <option>4–6 years</option>
              <option>6–8 years</option>
              <option>8+ years</option>
            </select>
          </div>

        </div>

        <div className="form-row form-row-2">

          <div className="fg">
            <label>Location</label>

            <input
              className="og-input"
              placeholder="Delhi, Bengaluru or Remote"
            />
          </div>

          <div className="fg">
            <label>Expected Joining Date</label>

            <input
              type="date"
              className="og-input"
            />
          </div>

        </div>

        <div className="form-row form-row-1">

          <div className="fg">
            <label>Key Skills Required</label>

            <input
              className="og-input"
              placeholder="React, TypeScript, Node.js… (comma separated)"
            />
          </div>

        </div>

      </div>
    </div>

    {/* Openings */}
    <div className="fs-bx" id="s-openings">

      <div className="fs-head">

        <i className="fs-icon fa-solid fa-users"></i>

        <h4>Number of Openings</h4>

        <span className="section-note">
          Each opening will become a separate job
        </span>

      </div>

      <div className="fs-body">

        <div className="form-row form-row-2 opening-row">

          <div className="fg">

            <label>
              Total Openings <span className="req">*</span>
            </label>

            <div className="opening-count-wrap">

              <input
                className="og-input opening-count-input"
                type="number"
                min="1"
                value="1"
                id="openingCount"
                
              />

              <span className="positions-label">
                positions
              </span>

            </div>

          </div>

          <div className="fg">

            <label className="note-label">
              Note
            </label>

            <div className="opening-note">
              HR will create one job posting per opening.
              You can specify different details per opening below.
            </div>

          </div>

        </div>

        <div id="openingsList">

          <div className="opening-block">

            <button
              className="ob-remove"
              onClick={(e) => removeOpening(e.currentTarget)}
              title="Remove"
            >
              <i className="fa-solid fa-times"></i>
            </button>

            <div className="opening-title">
              Opening 1 of 1
            </div>

            <div className="form-row form-row-2 opening-fields">

              <div className="fg">

                <label>
                  Specific Title (if different)
                </label>

                <input
                  className="og-input"
                  placeholder="Leave blank to use role title"
                />

              </div>

              <div className="fg">

                <label>Level</label>

                <select className="og-select">
                  <option>Mid-level</option>
                  <option>Junior</option>
                  <option>Senior</option>
                  <option>Lead</option>
                  <option>Principal</option>
                </select>

              </div>

            </div>

          </div>

        </div>

        <button
          className="btn btn-outline btn-sm add-opening-btn"
          onClick={addOpening}
        >
          <i className="fa-solid fa-plus"></i>
          Add Another Opening
        </button>

      </div>
    </div>

    {/* Budget */}
    <div className="fs-bx" id="s-comp">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-indian-rupee-sign"></i>
        <h4>Budget &amp; Compensation</h4>
      </div>

      <div className="fs-body">

        <div className="form-row form-row-3">

          <div className="fg">

            <label>Budget Min (per annum)</label>

            <div className="currency-wrap">

              <select className="og-select currency-select">
                <option>₹</option>
                <option>$</option>
              </select>

              <input
                className="og-input amount-input"
                type="number"
                placeholder="12"
              />

              <span className="lpa-label">
                LPA
              </span>

            </div>

          </div>

          <div className="fg">

            <label>Budget Max (per annum)</label>

            <div className="currency-wrap">

              <select className="og-select currency-select">
                <option>₹</option>
                <option>$</option>
              </select>

              <input
                className="og-input amount-input"
                type="number"
                placeholder="18"
              />

              <span className="lpa-label">
                LPA
              </span>

            </div>

          </div>

          <div className="fg">

            <label>Budget Flexibility</label>

            <select className="og-select">
              <option>Fixed — no flexibility</option>
              <option>Some flexibility (±10%)</option>
              <option>Fully negotiable</option>
            </select>

          </div>

        </div>

        <div className="fg">

          <label>
            Budget Justification{" "}
            <span className="field-help">
              (for Finance approval if needed)
            </span>
          </label>

          <textarea
            className="og-textarea"
            rows="2"
            placeholder="How was this budget range determined?"
          ></textarea>

        </div>

      </div>
    </div>

    {/* Justification */}
    <div className="fs-bx" id="s-reason">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-file-lines"></i>
        <h4>Justification &amp; Context</h4>
      </div>

      <div className="fs-body">

        <div className="fg">

          <label>
            Reason for Hiring <span className="req">*</span>
          </label>

          <select className="og-select">
            <option value="">Select reason…</option>
            <option>New position — team growth</option>
            <option>Replacement — employee resignation</option>
            <option>Replacement — employee transfer</option>
            <option>Backfill — employee termination</option>
            <option>New project requirement</option>
            <option>Seasonal / temporary</option>
          </select>

        </div>

        <div className="fg">

          <label>
            Detailed Justification <span className="req">*</span>
          </label>

          <textarea
            className="og-textarea"
            rows="5"
            placeholder="Explain why this position is needed, what impact it will have, and what problems it will solve. Include any relevant context (current workload, project timelines, team capacity, etc.)."
          ></textarea>

        </div>

        <div className="fg">

          <label>
            Replacing Employee{" "}
            <span className="field-help">
              (if backfill)
            </span>
          </label>

          <input
            className="og-input"
            placeholder="Name of departing employee (optional)"
          />

        </div>

      </div>
    </div>

    {/* Priority */}
    <div className="fs-bx" id="s-priority">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-flag"></i>
        <h4>Priority &amp; Timeline</h4>
      </div>

      <div className="fs-body">

        <div className="fg priority-field">

          <label>
            Hiring Priority <span className="req">*</span>
          </label>

          <div className="priority-opts">

            <div
              className="prio-opt"
             
            >
              <input
                type="radio"
                name="priority"
              />

              <div className="prio-label priority-normal">
                🟢 Normal
              </div>

              <div className="prio-sub">
                60–90 days acceptable
              </div>
            </div>

            <div
              className="prio-opt selected"
             
            >
              <input
                type="radio"
                name="priority"
                checked
                readOnly
              />

              <div className="prio-label priority-high">
                🟡 High
              </div>

              <div className="prio-sub">
                Within 30–45 days
              </div>
            </div>

            <div
              className="prio-opt"
              
            >
              <input
                type="radio"
                name="priority"
              />

              <div className="prio-label priority-critical">
                🔴 Critical
              </div>

              <div className="prio-sub">
                Fill within 2 weeks
              </div>
            </div>

          </div>
        </div>

        <div className="form-row form-row-2">

          <div className="fg">
            <label>Ideal Start Date</label>

            <input
              type="date"
              className="og-input"
            />
          </div>

          <div className="fg">
            <label>Hard Deadline (if any)</label>

            <input
              type="date"
              className="og-input"
            />
          </div>

        </div>

      </div>
    </div>

    {/* Notes */}
    <div className="fs-bx" id="s-notes">

      <div className="fs-head">
        <i className="fs-icon fa-solid fa-note-sticky"></i>
        <h4>Notes for HR</h4>
      </div>

      <div className="fs-body">

        <div className="fg">

          <label>
            Additional Notes{" "}
            <span className="field-help">
              (internal — not shared with candidates)
            </span>
          </label>

          <textarea
            className="og-textarea"
            rows="4"
            placeholder={`Any special requirements, preferences, or context that would help HR plan the recruitment.

e.g. Preferred: ex-startup experience, willing to work IST, must have worked with international clients…`}
          ></textarea>

        </div>

        <div className="fg">

          <label>
            Attach Supporting Document{" "}
            <span className="field-help">
              (optional)
            </span>
          </label>

          <input
            type="file"
            className="og-input support-file"
            accept=".pdf,.doc,.docx,.xls,.xlsx"
          />

        </div>

        <div className="hr-info-note">

          <i className="fa-solid fa-circle-info hr-info-icon"></i>

          HR will review this request within 2 working days.
          You will be notified via email when approved or if HR
          needs more information.

        </div>

      </div>
    </div>

    <div className="form-bottom-space"></div>

  </div>
</div>
        </div>
      </div>

      {/* Form Footer */}
      <div className="form-footer">
               

        <button className="btn btn-outline btn-sm">Discard</button>
        <button className="btn btn-outline btn-sm" onClick={() => toast('Request saved as draft')}>
          <i className="fa-regular fa-floppy-disk"></i> Save Draft
        </button>
        <button className="btn btn-primary btn-sm" onClick={submitRequest}>
          <i className="fa-solid fa-paper-plane"></i> Submit to HR
        </button>
      </div>

      {/* Discard Modal */}
    </>
  );
};

export default TalentRequestForm;